/**
 * @description tab状态管理
 * @author xiehan
 * @date 2018/9/19
 */
export default {
  state: {
    tabList: [],
    activeTab: ''
  },
  getters: {
    findTabByName: (state) => (name) => {
      return state.tabList.find(item => item.name === name)
    },
    findTabIndexByCode: (state) => (code) => {
      return state.tabList.findIndex(item => item.code === code)
    }
  },
  mutations: {
    addTab (state, tabInfo) {
      state.tabList.push(tabInfo)
    },
    removeTab (state, code) {
      if (state.tabList.length === 1) return
      let index = state.tabList.findIndex(item => item.code === code)
      state.tabList.splice(index, 1)
      if (code !== state.activeTab) return
      this.commit('setActiveTab', state.tabList[state.tabList.length - 1].code)
      this.commit('setActiveMenu', state.tabList[state.tabList.length - 1].code)
    },
    setActiveTab (state, code) {
      state.activeTab = code
    },
    setFullPath (state, payload) {
      let index = state.tabList.findIndex(item => item.code === payload.code)
      state.tabList[index].fullPath = payload.fullPath
    }
  },
  actions: {

  }
}
